import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "menu-button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickButton && _ctx.onClickButton(...args))),
    id: _ctx.btnDivId
  }, [...(_cache[1] || (_cache[1] = [
    _createElementVNode("div", { class: "menu-icon" }, null, -1)
  ]))], 8, _hoisted_1))
}